<template>
  <div>
    <!-- 表示するべきBookGroupが一つもなければ ”所持しているチケットがありません”-->
    <FacePhraseForIndexPage
      v-if="bookGroups.length == 0"
      phrase="所持しているチケットがありません"
    />

    <!-- 表示するべきBookGroupの一覧表示 -->
    <TheBookGroupsIndex :isUsedStatus="false" v-else />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateMyTicketsIndex",
  setup() {
    const store = useStore();
    const bookGroups = computed(() => store.getters["ticketing/bookGroups"]);

    return {
      bookGroups,
    };
  },
};
</script>
